<template>
    <div>
        <div class="fdc">
            <p class="fdc">
                <span class="lines"></span>
                <span class="fawer_text">{{comentTitle}}</span>
            </p>
            <span class="news" @click="onClick()">{{comentText}}</span>
        </div>
    </div>
</template>
<script>
export default {
   props:["comentTitle","comentText"],
   methods:{
       onClick(){
           this.$emit('onEitd')
       }
   } 
}
</script>
<style scoped>
.news{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/common/comentTitle.vue